import { gql } from "@outschool/ui-apollo";

export const EnrollmentMeetingCreateFutureMeetingsMutation = gql`
  mutation createEnrollmentFutureMeetings(
    $activityUid: String!
    $sectionUid: String!
    $startTime: DateTime!
    $endTime: DateTime
    $durationWeeks: Int
    $isRecurring: Boolean
    $meetingRequestUids: [String!]
    $orgTeacherUid: String # unfortunately the backend uses string and not id  so we have to do this to match
    $recurringScheduleUid: ID
  ) {
    createEnrollmentFutureMeetings(
      activityUid: $activityUid
      sectionUid: $sectionUid
      startTime: $startTime
      endTime: $endTime
      durationWeeks: $durationWeeks
      isRecurring: $isRecurring
      orgTeacherUid: $orgTeacherUid
      meetingRequestUids: $meetingRequestUids
      recurringScheduleUid: $recurringScheduleUid
    ) {
      uid
    }
  }
`;
